import { useEffect } from 'react';
import { useAppStore } from '../stores/appStore';
import { applyUserFacingControlTranslations } from './controlTextLocalization';

export default function ControlTextLocalizer() {
  const language = useAppStore((state) => state.language);

  useEffect(() => {
    if (typeof document === 'undefined') return;

    let frameId: number | null = null;
    const apply = () => {
      frameId = null;
      applyUserFacingControlTranslations(document.body, language);
    };
    const scheduleApply = () => {
      if (frameId !== null) return;
      frameId = window.requestAnimationFrame(apply);
    };

    scheduleApply();
    const observer = new MutationObserver((mutations) => {
      if (!mutations.some((mutation) => (
        mutation.type === 'childList'
        || mutation.type === 'characterData'
        || mutation.type === 'attributes'
      ))) {
        return;
      }
      scheduleApply();
    });

    observer.observe(document.body, {
      subtree: true,
      childList: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['aria-label', 'title', 'placeholder'],
    });

    return () => {
      observer.disconnect();
      if (frameId !== null) window.cancelAnimationFrame(frameId);
    };
  }, [language]);

  return null;
}

